import {AfterViewInit, Component, Injector, ViewChild} from '@angular/core';
import {BaseWrapperComponent} from '@twpub/shared/components/base';
import {FieldFilter, FilterSelector, SearchFilter, SessionObject} from '@twpub/core/models';
import {ComponentCategory, SessionParam} from '@twpub/core/enums';
import {SearchFilterService} from '@twpub/core/services/search-filter.service';
import {FilterSelectorDirective} from './filter-selector.directive';

@Component({
  selector: 'pub-filter-wrapper',
  template: '<ng-template pubFilter></ng-template>',
  standalone: true,
  imports: [FilterSelectorDirective]
})
export class FilterWrapperComponent extends BaseWrapperComponent<FilterSelector> implements AfterViewInit {
  override compCategory = ComponentCategory.Filter;
  override changesTriggers: SessionParam[] = [SessionParam.DICT_IDS, SessionParam.FIELD_FILTERS];
  searchFilters: SearchFilter[] = []
  searchFiltersValues: FieldFilter[] = []
  @ViewChild(FilterSelectorDirective, {static: true}) pubFilter!: FilterSelectorDirective
  private filterSubscriptionSetup = false;

  constructor(injector: Injector, private filterService: SearchFilterService) {
    super(injector)
  }

  getViewContainerRef = () => this.pubFilter.viewContainerRef;

  ngAfterViewInit(): void {
    this.setupFilterSubscription();
  }

  private setupFilterSubscription(): void {
    if (this.filterSubscriptionSetup || !this.componentRef) return;

    const comp = this.componentRef.instance;
    if (comp && comp.updateFieldFilter) {
      this.subscriptions.add(
        comp.updateFieldFilter.subscribe((fieldFilters: FieldFilter[]) => {
          this.sharedStateService.addFieldFilters(fieldFilters);
        })
      );
      this.filterSubscriptionSetup = true;
    }
  }

  protected override handleSessionChanges(session: Partial<SessionObject>) {
    if (session.dictIds) {
      this.fetchFilters(session.dictIds);
    }
    if (session.fieldFilters !== undefined) {
      // Sync filter state from session - this keeps multiple filter instances in sync
      this.update();
    }
  }

  private fetchFilters(dictIds: number[]) {
    this.filterService.getSearchFilters(dictIds).subscribe((filters) => {
      this.searchFilters = filters;
      this.searchFiltersValues = filters.map((filter) => ({
        fieldKey: filter.fieldKey,
        values: [],
        dictionaryId: filter.dictionaryId || 0
      }));
      this.update();
    });
  }

  override createComponent(): FilterSelector {
    const comp = super.createComponent();
    this.setupFilterSubscription();
    const dictIds = this.sharedStateService.getDictionaryIds();
    if (dictIds) this.fetchFilters(dictIds);
    return comp;
  }

  override update() {
    super.update((comp) => {
      const fieldFilters = this.sharedStateService.getFieldFilters();
      comp.searchFilters = this.searchFilters;
      comp.fieldFilters = fieldFilters || this.searchFiltersValues;
    });
    this.setupFilterSubscription();
  }
}
